<template>
  <div id="goodslists">
    <div class="tableheader">
      <el-button @click="editGoods(-1)" class="btn1" type="primary" size="small">添加操作提示</el-button>
    </div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
		<el-table-column prop="type" label="唯一key"></el-table-column>
        <el-table-column prop="lang" label="语言"></el-table-column>
		<el-table-column label="操作">
			<template slot-scope="scope">
			  <el-button @click="editGoods(scope.row)" class="btn1" type="primary" size="mini">编辑</el-button>
			</template>
		</el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tipslist',
  data () {
    return {
      doing: false,
      lists: null
    }
  },
  computed: {

  },
  created () {
    this.getList();
  },
  methods: {
    getList () {
      let _this = this
      let data = this.sForm
      this.axios.post('/skinMgrSrv/tips/list', {}).then(function (response) {
        if (response.data.code === 0) {
          _this.lists = response.data.list
        }
      }).catch(function (res) {})
    },
    editGoods (goods) {
      localStorage.goodlistParam = JSON.stringify(this.sForm);
      localStorage.edit_goods = JSON.stringify(goods)
      localStorage.activeMenu = '操作提示文案管理'
      this.$router.push({ path: '/skinmgr/tipsEdit'})
    }
  }
}
</script>
<style  lang="scss">
  #goodslists{
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
    .el-button--primary {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
      -webkit-box-shadow: -1px 0 0 0 #57AEC9;
      box-shadow: -1px 0 0 0 #57AEC9;
    }
    .dialog-footer-center{
      text-align: center;
    }
  }

</style>
<style scoped lang="scss">
  #goodslists {
    margin: 0.16rem;
    padding: 0.16rem;
    background-color: #fff;
    border-radius: 0.04rem;
    box-sizing: border-box;
    .tableheader{
      margin-top: 0.0833rem;
    }
    p.title{
      height: 0.4167rem;
      line-height:0.4167rem;
      font-size:0.15rem;
      color:#000;
    }
    .btn2,.btn3{
      padding: 0.0667rem 0.0833rem;
    }
    .codeshearch{
      width: 1.667rem;
    }
    .btn3,.codeshearch{
      float: right;
      margin-right: 0.0833rem;
    }
    .codeshearch{
      width: 1.25rem;
    }
    .deviceAddBlock{
      margin-top: 0.0833rem;
    }
    .goods_name{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .lh18{
      margin-bottom: 0.1rem;
      line-height: 180%;
    }
    .modelxls{
      position:absolute;
      border: 1px solid #ccc;
      top: 0.7rem;
      right: 0.2rem;
      width: 0.9rem;
      height: 1.2rem;
      text-align: center;
      padding-top: 0.1rem;
      a{
        margin-top: 0.1rem;
        border: 1px solid #ccc;
        height: 0.25rem;
        line-height: 0.25rem;
        border-radius: 0.15rem;
        width: 0.7rem;
        display: block;
        margin-left: 0.1rem;
      }
    }
    .uploadbutton{
      width: 100%;
      height: auto;
      margin-top: 0.5rem;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/tips/list.vue